import { render, staticRenderFns } from "./BuddhismRegistrationInfo.vue?vue&type=template&id=093b857a"
import script from "./BuddhismRegistrationInfo.vue?vue&type=script&lang=js"
export * from "./BuddhismRegistrationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports